import { Copy, Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

import CopyButtonWithAnimation from '../reusable/CopyButtonWithAnimation'

export const SensitiveFieldRow = ({
  enableCopyButton = false,
  label,
  omitIfUndefined = false,
  value,
  isHidden = false,
}: {
  enableCopyButton?: boolean
  label: string
  omitIfUndefined?: boolean
  value?: string | null
  isHidden?: boolean
}) => {
  const [isRevealed, setIsRevealed] = useState(false)

  if (omitIfUndefined && value === undefined) {
    return null
  }

  if (!value) {
    return (
      <div className='px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0'>
        <dt className='text-sm font-medium leading-6 text-gray-900'>{label}</dt>
        <dd className='mt-1 text-sm leading-6 text-gray-400 sm:col-span-2 sm:mt-0'>
          (none)
        </dd>
      </div>
    )
  }

  return (
    <div className='px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0'>
      <dt className='text-sm font-medium leading-6 text-gray-900'>{label}</dt>
      <dd className='mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 flex items-center'>
        {isHidden && !isRevealed
          ? (
            <div className='flex items-center'>
              <button
                onClick={() => setIsRevealed(true)}
                className='inline-flex items-center px-2 py-1 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              >
                <Eye size={12} className='mr-1' />
                Show
              </button>
            </div>
            )
          : (
            <div className='flex items-center'>
              <span className='sensitive'>{value}</span>
              {enableCopyButton && (
                <CopyButtonWithAnimation content={value}>
                  <Copy size={16} strokeWidth={1} />
                </CopyButtonWithAnimation>
              )}
              {isHidden && (
                <button
                  onClick={() => setIsRevealed(false)}
                  className='ml-2 text-gray-400 hover:text-gray-600'
                >
                  <EyeOff size={16} strokeWidth={1} />
                </button>
              )}
            </div>
            )}
      </dd>
    </div>
  )
}

export default SensitiveFieldRow
